module.exports = __webpack_public_path__ + "static/img/wdtx1-2.a8e26d4.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/word/wdtx1-2.png
// module id = 896
// module chunks = 0